export default __webpack_public_path__ + "static/PaineG-fd1db36f7cf41c6e52aff6116fa9bdc0.png";